import React, { Component } from 'react';
import { loadScripts } from '../../utils.js';
import './crossrefs.css';


export default class CrossrefsPage extends Component {

  componentDidMount() {
    // @TEMP original prototype tool was developed in jQuery
    const parent = document.getElementsByClassName('crossrefs-page')[0];
    loadScripts([
      '/jquery/jquery.csvtojson.min.js',
      '/jquery/jquery.crossrefs.js'
    ], parent, () => {
      const yearUUID = this.props.location.state && this.props.location.state.activeYear;
      // Pass an empty options object if year isn't selected so that we use the default FY19/20 value
      const options = yearUUID ? {yearUUID} : {};
      // jQuery is global via /public/index.html
      // eslint-disable-next-line
      window.$('.crossrefs-page').mdCrossrefs(options);
    });
  }

  componentWillUnmount() {
    // @TODO beware of memory leaks...
  }

  render() {
    return (
      <div className='crossrefs-page' />
    );
  }
}
